import { render, staticRenderFns } from "./TimeOffReminders.vue?vue&type=template&id=22977c83&"
import script from "./TimeOffReminders.vue?vue&type=script&lang=js&"
export * from "./TimeOffReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports